export const getOrderStatusColorForCustomer = (status) => {
    if (!status) {
        return 'bg-black text-white';
    }
    switch (status) {
        case 'NEEDS_REVIEW':
            return 'bg-[#F9E7AF] text-[#000033]';
        case 'UNASSIGNED':
            return 'bg-[#F4CFA3] text-[#000033]';
        case 'ASSIGNED':
            return 'bg-[#F4CFA3] text-[#000033]';
        case 'CANCELLED':
            return 'bg-[#D22222] text-white';
        case 'COMPLETED':
            return 'bg-[#238823] text-white';
        case 'DELIVERED':
            return 'bg-[#D9E2C4] text-[#000033]';
        case 'DUMPED':
            return 'bg-[#D3BEE4] text-[#000033]';
        case 'ON_HOLD':
            return 'bg-[#F9E7AF] text-[#000033]';
        case 'PICKED_UP_EMPTY':
            return 'bg-[#D3BEE4] text-[#000033]';
        case 'PICKED_UP_FULL':
            return 'bg-[#D3BEE4] text-[#000033]';
        case 'READY_FULL_PICKUP':
            return 'bg-[#F4CFA3] text-[#000033]';
        case 'READY_EMPTY_PICKUP':
            return 'bg-[#F4CFA3] text-[#000033]';
        default:
            return 'bg-black text-white';
    }
};
//# sourceMappingURL=get-order-status-color.js.map